import React, { useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { Done, Cookie, ArrowForward } from "@icons";

export const CookiePanel = ({isCookiesAccepted, setIsCookiesAccepted}) => {
	const cookieName = "EnviMAP";

	// Get initial value
	useEffect(() => {
    const cookieValue = getCookieConsentValue(cookieName);
		setIsCookiesAccepted(cookieValue ? true : false);
  }, [setIsCookiesAccepted]);

	return (
		<CookieConsent
			disableStyles={true}
			containerClasses={"cookie " + (isCookiesAccepted ? "hidden" : "")}
			contentClasses="cookie__body"
			buttonWrapperClasses="cookie__button"
			buttonText={<Done/>}
			cookieName={cookieName}
			onAccept={() => setIsCookiesAccepted(true)}
		>
			<div className="cookie__body__icon">
				<Cookie color={"white"}/>
			</div>
			<div className="cookie__body__content">
				<p>A weboldal sütiket használ a felhasználói élmények növeléséhez.</p>
				<a
					className="cookie__body__content__link"
					href="/Cookie_Szabalyzat_Envimap.pdf"
					target="_blank"
					rel="noreferrer"
				>
					<p>További információk</p>
					<ArrowForward/>
				</a>
			</div>
		</CookieConsent>
	)
};